// utils/stringExtensions.ts (or .js)
declare global {
    interface String {
        isEmpty(): boolean;
        toSentenceCase(): string;
    }
}

String.prototype.isEmpty = function () {
    return (this == null || this.replace(/ /gi, "").length == 0)
};

String.prototype.toSentenceCase = function () {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

export { }; // Required for TypeScript module augmentation
